import type React from "react";

export const MeditationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 512.156 512.156"
      {...restProps}
    >
      <title>Meditation Icon</title>
      <g>
        <path
          d="M479.993 327.169h-17.172a17.149 17.149 0 0 1-13.868-7.06l-96.208-132.234a40.642 40.642 0 0 0-32.29-15.962h-21.153a8.274 8.274 0 0 1-8.274-8.274v-19.601c0-3.87 1.979-7.449 5.213-9.574 20.114-13.213 33.318-36.084 33.015-62.018C328.789 32.508 295.755.034 255.814.217c-40.216.185-72.761 32.843-72.761 73.103 0 25.562 13.12 48.06 32.994 61.127 3.243 2.132 5.239 5.712 5.239 9.594v19.598a8.274 8.274 0 0 1-8.274 8.274h-26.764a40.642 40.642 0 0 0-32.29 15.962L57.903 321.169a17.15 17.15 0 0 1-13.914 7.124H32.162C14.4 328.292 0 342.692 0 360.455c0 17.763 14.399 32.162 32.162 32.162h31.595c-19.493 10.89-32.682 31.715-32.682 55.63 0 35.176 28.516 63.692 63.692 63.692h269.827L152.624 394.49a146.48 146.48 0 0 0-52.967-9.935h-1.249a36.801 36.801 0 0 0 6.678-6.924l61.073-90.942v80.16c.296.14.594.272.885.433l89.753 49.745 83.748-50.241v-80.097l61.229 89.818a36.8 36.8 0 0 0 7.017 7.194c-23.155.346-47.608 6.708-68.246 18.171v-.102l-53.436 32.057 137.145 76.011c29.28-5.739 51.375-31.53 51.375-62.49v-.306c0-24.024-13.306-44.791-32.945-55.548h37.31c17.763 0 32.162-14.399 32.162-32.162 0-17.764-14.4-32.163-32.163-32.163z"
          fill={color}
        />
      </g>
    </svg>
  );
};
